export const errorMessages = {
  en: {
    errors: {
      timeout: 'Request timed out. Please try again.',
      networkError: 'Network error. Please check your connection.',
      badRequest: 'Invalid request. Please check your input.',
      unauthorized: 'Please log in to continue.',
      forbidden: 'You do not have permission to access this resource.',
      notFound: 'The requested resource was not found.',
      serverError: 'Server error. Please try again later.',
      unknown: 'An unexpected error occurred. Please try again.'
    }
  },
  tr: {
    errors: {
      timeout: 'İstek zaman aşımına uğradı. Lütfen tekrar deneyin.',
      networkError: 'Ağ hatası. Lütfen bağlantınızı kontrol edin.',
      badRequest: 'Geçersiz istek. Lütfen girdiğiniz bilgileri kontrol edin.',
      unauthorized: 'Devam etmek için lütfen giriş yapın.',
      forbidden: 'Bu kaynağa erişim izniniz yok.',
      notFound: 'İstenen kaynak bulunamadı.',
      serverError: 'Sunucu hatası. Lütfen daha sonra tekrar deneyin.',
      unknown: 'Beklenmeyen bir hata oluştu. Lütfen tekrar deneyin.'
    }
  }
}; 